import { createContext } from 'react';

export default createContext({
  isLoading: false,
  emptyValue: '',
});
